import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { Notification, NotificationData } from './notification.model';

export class MedicalHistoryNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    this.actionName = this.translateService.instant('view_access');
    this.actionRequired = !this.readDate;
    const requestDate = DateTime.fromISO(data?.medicalHistoryRequest?.requested_timestamp);
    this.description = this.translateService.instant('medical_history_request_description', {
      doctor: data?.medicalHistoryRequest?.doctor_name ?? this.translateService.instant('a_practitioner'),
      time: requestDate.toFormat('HH:mm'),
      date: requestDate.toFormat('cccc, dd LLLL'),
    });
  }
}
